import { utils, writeFile } from "xlsx";

const exportToExcel = (data, fileName) => {
    const workBook = utils.book_new();
    const workSheet = utils.json_to_sheet(data);

    const MAX_WIDTH = 20; // Set your desired maximum width here

    const columnWidths = data.reduce((acc, row) => {
        Object.keys(row).forEach((key, index) => {
            const cellValue = row[key];
            const cellWidth = (cellValue || "").toString().length + 2;

            // Cap the width at the maximum
            acc[index] = acc[index] || { wch: MAX_WIDTH };
            if (cellWidth > MAX_WIDTH) {
                acc[index] = { wch: MAX_WIDTH };
            } else if (cellWidth > acc[index].wch) {
                acc[index] = { wch: cellWidth };
            }
        });
        return acc;
    }, []);

    workSheet["!cols"] = columnWidths;

    utils.book_append_sheet(workBook, workSheet, "Sheet 1");
    writeFile(workBook, `${fileName || "download"}.xlsx`);
};

export default exportToExcel;
